
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import TerminalData from "./TerminalData";

export default {
  name: "app-terminal-update",
  data() {
    return {
      terminal: new TerminalData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getTerminal(uuid_terminal) {
      const { data } = await this.$http.post("/terminalVenda/find", {
        uuid_terminal,
      });
      return data;
    },
    async getInit() {
      try {
        const uuid_terminal = this.$route.params.uuid_terminal;

        this.setLoading(true);
        const terminal = await this.getTerminal(uuid_terminal);
        this.setLoading(false);

        if (!terminal || !terminal.uuid_terminal) {
          this.$router.push({ name: "terminais" });
          return this.$toast.error("Terminal não encontrado!");
        }

        this.terminal = new TerminalData(terminal);
      } catch {
        this.setLoading(false);
      }
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
      return;
    }
    this.getInit();
  },
};
